import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import {of, from, tap} from 'rxjs';
import {switchMap, map, catchError, withLatestFrom, filter} from 'rxjs/operators';
import { Store } from '@ngrx/store';

import {AppState} from "../app.state";
import {
  getUsersRoleAndTenantData, getUsersRoleAndTenantDataFailure,
  getUsersRoleAndTenantDataSuccess,
} from "./auth.action";
import {MsalBroadcastService} from "@azure/msal-angular";
import {TenantRoleService} from "../../data-access/tenant-role.service";

@Injectable()
export class AuthEffects {
  getUsersRoleAndTenantData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getUsersRoleAndTenantData),
      switchMap((action) =>
        this.tenantRoleService.getRoleAndTenantData(action.tenantId, action.roleId)
          .pipe(
            map((tenantAndRole) => getUsersRoleAndTenantDataSuccess({tenantRoleData: tenantAndRole})),
            catchError((error) => of(getUsersRoleAndTenantDataFailure({ error })))
          )
      )
    )
  );


  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private broadcastService: MsalBroadcastService,
    private tenantRoleService: TenantRoleService,
  ) {}
}
